export default point => {
  const {map, layers} = riot.STORE.mapbox
  return map.queryRenderedFeatures(point, {layers})[0]
}



// WEBPACK FOOTER //
// ./src/components/mapbox-map/get_feature.js